<template>
	<div class="mt-3">
		<template v-if="!loading">
			<v-row>
				<v-col cols="12" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showModalCari">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</v-row>
			<v-row v-if="historySerialList.length > 0">
				<v-col cols="12" class="pt-0">
					<v-data-table hide-default-footer disable-sort :headers="table_headers" :items="historySerialList" :items-per-page="parseInt(limit)" class="table-vo" no-data-text="Tidak ada data tersedia">
						<template v-slot:[`item.receiver`]="{ item }">
							{{ item.serial_transfer_log_serial_receiver_member_name }}
						</template>
						<template v-slot:[`item.kode`]="{ item }">
							<div>{{ item.serial_transfer_log_serial_receiver_network_code }}</div>
						</template>
						<template v-slot:[`item.total_in`]="{ item }">
							<div class="cl-primary font-weight-500">{{ item.serial_transfer_log_serial_receiver_total_in }}</div>
						</template>
						<template v-slot:[`item.total_out`]="{ item }">
							<div class="cl-primary font-weight-500">{{ item.serial_transfer_log_serial_receiver_total_out }}</div>
						</template>
						<template v-slot:[`item.detail`]="{ item }">
							<v-btn depressed color="indo lighten-1" class="mr-2 darkgrey--text lighten-5 rounded-xl text-capitalize" @click="showModalDetail(serial_id, item.serial_transfer_log_serial_receiver_network_code)"><v-icon dense class="mr-2">mdi-eye</v-icon> Detail</v-btn>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="historySerialList.length <= 0">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada riwayat serial yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div v-if="historySerialList.length > 0">
				<v-row justify="end">
					<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
						<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historySerialPagination.total_page" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
						<div class=" font-size-10">Menampilkan {{ historySerialPagination.total_display }} data dari total {{ historySerialPagination.total_data }} data</div>
					</v-col>
					<v-col cols="4" sm="2" md="1">
						<v-select :items="limit_list" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="primary" @input="changeLimit"></v-select>
					</v-col>
				</v-row>
			</div>
		</template>
		<div class="mt-4" v-if="loading">
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
		<ModalDetail ref="modalDetail"></ModalDetail>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';
import ModalDetail from './components/ModalDetailHistory';

export default {
	components: {
		ModalCari,
		ModalDetail
	},
	props: {
		serial_id: String,
	},
	data() {
		return {
			loading: true,
			page: 1,
			limit: '10',
			limit_list: [ '10', '20', '50', '100' ],
			params: [],
			table_headers: [
				{ text: 'Penerima', width: '20%', align: 'start', value: 'receiver' },
				{ text: 'Kode Mitra', width: '20%', align: 'start', value: 'kode' },
				{ text: 'Jumlah Diterima', width: '20%', align: 'center', value: 'total_in' },
				{ text: 'Jumlah Dikirim', width: '20%', align: 'center', value: 'total_out' },
				{ text: 'Aksi', width: '20%', align: 'start', value: 'detail' }
			]
		}
	},
	computed: {
		...mapState('serial', ['historySerialList', 'historySerialPagination']),
	},
	methods: {
		...mapActions('serial', ['getHistorySerialList']),

		showModalCari() {
			this.$refs.modalCari.modalShow()
		},

		showModalDetail(serial_id, receiver_member_id) {
			this.$refs.modalDetail.modalShow(serial_id, receiver_member_id)
		},

		reset() {
			this.params = []
			this.page = 1
			this.getData()
			this.$refs.modalCari.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.date.value)
				this.params.push(data.date)

			if(data.serial.value)
				this.params.push(data.serial)

			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			const params = this.queryString({ limit:this.limit, page: this.page, params: this.params, sort: 'serial_transfer_log_serial_datetime', dir: 'desc' })
			let data = {
				id: this.serial_id,
				params: params
			}
			this.getHistorySerialList(data).then(() => {
				this.$refs.modalCari.modalHide()
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Riwayat Kirim Serial`)
	},
};
</script>